import { tos } from './tos'

export default (): { __html: string } => ({ __html: `<!DOCTYPE html> ${tos}` })
